import { EstensaColDef } from "../../../search-page/search-param.model";


export class DetailItem {
    private _estensaColDef: EstensaColDef;
    private _data: any;

    constructor(estensaColDef: EstensaColDef, data:any) {
        this._estensaColDef = estensaColDef;
        this._data = data;
    }

    get estensaColDef() {
        return this._estensaColDef;
    }

    get value() {
        if (this.estensaColDef.field)
            return this.retrieveValue();
        else if (!!this.estensaColDef.context.estensaDetails.valueGetter)
            return this.estensaColDef.context.estensaDetails.valueGetter(this._data)

        return null;    
    }

    private retrieveValue(): any {
        let rowValue = this.getPath();
        if (!!this._estensaColDef.context.estensaDetails && this._estensaColDef.context.estensaDetails.valueFormatter) {
            return this._estensaColDef.context.estensaDetails.valueFormatter.call(rowValue, this._data);
        }
        return rowValue;
    }

    private getPath(): any {
        try {
            return this._estensaColDef.field.split('.').reduce((accumulator, currentField) => accumulator[currentField], this._data);
        }
        catch {
            return null;
        }
    }

    get data(): any {
        return this._data;
    }

    public withNewColDef(newColDef: EstensaColDef): DetailItem {
        // Crea una NUOVA istanza usando i dati originali (_data) 
        // e il nuovo riferimento a EstensaColDef
        return new DetailItem(newColDef, this._data);
    }
}
